// bao migrate skip
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialogViewModel from "./../../factories/bao-dialog";
function ConfigurationItemTypeManufacturerTypeDialog(tabPage, parent) {
    var self = this;
    self.ConfigurationItem = parent.ConfigurationItemType;
    var _deleteMessageRefDocument = Bao.Session.GetMessage("msgDeleteConfigurationItemTypeManufacturerTypeReferenceDocument");
    self.Dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
    self.Dialog.Width("750px");
    self.Dialog.Buttons([{
            Title: Bao.Session.GetMessage("msgOk"),
            Click: function () {
                if (!self.ValidateDialog()) {
                    return;
                }
                self.DialogResult("ok");
                self.Dialog.Close();
            },
            Enabled: ko.observable(true)
        }, {
            Title: Bao.Session.GetMessage("msgCancel"),
            Click: function () {
                self.Dialog.Close();
            },
            Enabled: ko.observable(true)
        }]);
    self.DialogViewModel = {};
    self.DialogViewModel.Bao = Bao;
    self.DialogResult = ko.observable();
    self.DialogViewModel.TotalRows = ko.observable();
    self.DialogViewModel.PageIndex = ko.observable(0);
    self.DialogViewModel.PageSize = ko.observable(20);
    self.DialogViewModel.ManufacturerTypeDocumentCollection = ko.observableArray();
    self.DialogViewModel.SelectedManufacturerTypeReferenceDocumentRow = ko.observable();
    self.DialogViewModel.ManufacturerTypeReferenceDocumentButtons = ko.observableArray();
    self.DialogViewModel.SortingManufacturerTypeReferenceDocument = ko.observableArray();
    self.DialogViewModel.ToolbarButtons = ko.observableArray([]);
    self.Name = ko.observable();
    self.Description = ko.observable();
    self.SupportDate = ko.observable();
    self.SupportDateJs = ko.observable();
    self.DialogViewModel.CustomerFilterId = ko.observable();
    self.DialogViewModel.ToolbarButtons.subscribe(function () {
        self.DialogViewModel.ToggleToolbarButtons();
    });
    self.DialogViewModel.SelectedManufacturerTypeReferenceDocumentRow.subscribe(function () {
        self.DialogViewModel.ToggleToolbarButtons();
    });
    self.DialogViewModel.RefreshGrid = function () {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemType/GetConfigurationItemTypeManufacturerTypeReferenceDocumentCollection", JSON.stringify({
            sessionTabId: parent.ConfigurationItemType.TabPage.SessionTabId,
            manufacturerTypeId: self.DialogViewModel.ManufacturerTypeId(),
            pageIndex: self.DialogViewModel.PageIndex(),
            pageSize: self.DialogViewModel.PageSize(),
            sorting: self.DialogViewModel.SortingManufacturerTypeReferenceDocument()
        }), function (searchResult) {
            tabPage.IsLoading(false);
            self.DialogViewModel.SelectedManufacturerTypeReferenceDocumentRow(null);
            self.DialogViewModel.TotalRows(0);
            self.DialogViewModel.ManufacturerTypeDocumentCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.DialogViewModel.ManufacturerTypeDocumentCollection(searchResult.Models);
                self.DialogViewModel.TotalRows(searchResult.TotalRows);
            }
        });
    };
    self.DialogViewModel.ToggleToolbarButtons = function () {
        ko.utils.arrayForEach(self.DialogViewModel.ToolbarButtons(), function (button: any) {
            switch (button.ActionKey()) {
                case "ConfigurationItemTypeManufacturerTypeReferenceDocumentEdit":
                case "ConfigurationItemTypeManufacturerTypeReferenceDocumentRemove":
                case "ConfigurationItemTypeManufacturerTypeReferenceDocumentExport":
                    button.Enabled(!(self.DialogViewModel.SelectedManufacturerTypeReferenceDocumentRow() == null));
                    break;
            }
        });
    };
    self.DialogViewModel.AddConfigurationItemTypeManufacturerTypeReferenceDocument = function (model, manufacturerTypeId) {
        tabPage.IsLoading(true);
        if (model.IsDocumentNew() == true) {
            self.DialogViewModel.DocumentCount(self.DialogViewModel.DocumentCount() + 1);
        }
        Bao.post("ConfigurationItemType/AddConfigurationItemTypeManufacturerTypeReferenceDocument", JSON.stringify({
            sessionTabId: parent.ConfigurationItemType.TabPage.SessionTabId,
            manufacturerTypeReferenceDocumentModel: ko.map.toJS(model),
            manufacturerTypeId: manufacturerTypeId
        }), function () {
            parent.ConfigurationItemType.TabPage.DirtyFlag(true);
            self.DialogViewModel.RefreshGrid();
        });
    };
    self.DialogViewModel.DeleteConfigurationItemTypeManufacturerTypeReferenceDocument = function (manufacturerTypeId, configurationItemTypeManufacturerTypeReferenceDocumentId) {
        self.DialogViewModel.DocumentCount(self.DialogViewModel.DocumentCount() - 1);
        return Bao.post("ConfigurationItemType/DeleteConfigurationItemTypeManufacturerTypeReferenceDocument", JSON.stringify({
            sessionTabId: parent.ConfigurationItemType.TabPage.SessionTabId,
            manufacturerTypeId: manufacturerTypeId,
            configurationItemTypeManufacturerTypeReferenceDocumentId: configurationItemTypeManufacturerTypeReferenceDocumentId
        }), function () {
            parent.ConfigurationItemType.TabPage.DirtyFlag(true);
            self.DialogViewModel.RefreshGrid();
        });
    };
    self.DialogViewModel.EditConfigurationItemTypeManufacturerTypeReferenceDocument = function (configurationItemTypeManufacturerId, configurationItemTypeManufacturerTypeReferenceDocumentId) {
        if (self.DialogViewModel.SelectedManufacturerTypeReferenceDocumentRow() != null) {
            self.DialogViewModel.ShowConfigurationItemTypeManufacturerTypeReferenceDocumentDialog(parent.ConfigurationItemType.ConfigurationItemTypeId(), self.DialogViewModel.ManufacturerTypeId(), self.DialogViewModel.SelectedManufacturerTypeReferenceDocumentRow().OpenData);
        }
    };
    self.DialogViewModel.ShowConfigurationItemTypeManufacturerTypeReferenceDocumentDialog = function (configurationItemTypeId, manufacturerTypeId, configurationItemTypeManufacturerTypeReferenceDocumentId) {
        window.baorequire(["ViewModels/Dialogs/ConfigurationItemTypeManufacturerTypeReferenceDocumentDialog"], function (vm) {
            var dialog = new vm(tabPage, parent);
            dialog.Show(configurationItemTypeId, manufacturerTypeId, configurationItemTypeManufacturerTypeReferenceDocumentId);
            dialog.DialogResult.subscribe(function (dialogResult) {
                if (dialogResult == "ok") {
                    self.DialogViewModel.AddConfigurationItemTypeManufacturerTypeReferenceDocument(dialog.DialogViewModel, self.DialogViewModel.ManufacturerTypeId());
                }
            });
        });
    };
    self.toolbarDocumentClick = function (item) {
        debugger;
    };
    self.DialogViewModel.toolbarDocumentClick = function (action) {
        switch (action.ActionKey()) {
            case "ConfigurationItemTypeManufacturerTypeReferenceDocumentAdd":
                self.DialogViewModel.ShowConfigurationItemTypeManufacturerTypeReferenceDocumentDialog(parent.ConfigurationItemType.ConfigurationItemTypeId(), self.DialogViewModel.ManufacturerTypeId(), null);
                break;
            case "ConfigurationItemTypeManufacturerTypeReferenceDocumentEdit":
                if (self.DialogViewModel.SelectedManufacturerTypeReferenceDocumentRow() != null) {
                    self.DialogViewModel.ShowConfigurationItemTypeManufacturerTypeReferenceDocumentDialog(parent.ConfigurationItemType.ConfigurationItemTypeId(), self.DialogViewModel.ManufacturerTypeId(), self.DialogViewModel.SelectedManufacturerTypeReferenceDocumentRow().OpenData);
                }
                break;
            case "ConfigurationItemTypeManufacturerTypeReferenceDocumentRemove":
                var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessageRefDocument, "yesno");
                yesNoDialog.DialogResult.subscribe(function (result) {
                    if (result === true) {
                        self.DialogViewModel.DeleteConfigurationItemTypeManufacturerTypeReferenceDocument(self.DialogViewModel.ManufacturerTypeId(), self.DialogViewModel.SelectedManufacturerTypeReferenceDocumentRow().OpenData);
                    }
                });
                break;
            case "ConfigurationItemTypeManufacturerTypeReferenceDocumentExport":
                if (self.DialogViewModel.SelectedManufacturerTypeReferenceDocumentRow() != null) {
                    self.DialogViewModel.DownloadConfigurationItemTypeManufacturerTypeReferenceDocument(self.DialogViewModel.SelectedManufacturerTypeReferenceDocumentRow().ManufacturerTypeReferenceDocumentId);
                }
                break;
        }
    };
    self.DialogViewModel.DownloadConfigurationItemTypeManufacturerTypeReferenceDocument = function (manufacturerTypeReferenceDocumentId) {
        window.open(Bao.Content("ConfigurationItemType/ManufacturerTypeReferenceDocumentDownload?id=" + manufacturerTypeReferenceDocumentId));
    };
    self.DialogViewModel.ConfigurationItemTypeManufacturerTypeCategoryId = ko.observable();
    self.DialogViewModel.PersonId = ko.observable();
    self.ValidateDialog = function () {
        var isComplete = true;
        if (self.DialogViewModel.ManufacturerTypeId() == null || Bao.Utils.String.IsNullOrEmpty(self.DialogViewModel.Name())) {
            isComplete = false;
        }
        if (isComplete == false) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
    self.GetCustomerId = function () {
        if (self.ConfigurationItem != null) {
            return self.ConfigurationItem.ConfigurationItemTypeId;
        }
        return null;
    };
    self.Show = function (configurationItemTypeId, configurationItemTypeManufacturerId, manufacturerTypeId) {
        tabPage.IsLoading(true);
        Bao.post("ConfigurationItemType/ShowConfigurationItemTypeManufacturerTypeDialog", JSON.stringify({
            sessionTabId: parent.ConfigurationItemType.TabPage.SessionTabId,
            configurationItemTypeId: configurationItemTypeId,
            configurationItemTypeManufacturerId: configurationItemTypeManufacturerId,
            manufacturerTypeId: manufacturerTypeId
        }), function (value) {
            ko.map.fromJS(value.Model, self.DialogViewModel, ko.dirtyFlag());
            self.DialogViewModel.CustomerFilterId(self.GetCustomerId());
            self.DialogViewModel.RefreshGrid();
            self.Dialog.ViewModel(self.DialogViewModel);
            self.Dialog.Template(value.Message);
            self.Dialog.Open();
            tabPage.IsLoading(false);
        });
    };
}
export default ConfigurationItemTypeManufacturerTypeDialog;